import React, { useContext } from 'react';
import ProductManager from '../common/ProductPage/ProductManager';
import { getFormattedDate } from '../common/HelperMethods';
import { ProductChannel } from '../../consts/Common';
import { SiteContext } from '../../context/SiteContext';
import { ProductFilter } from '../common/CommonTypes';
import { useJourney } from './Layout';

const ProductPage = (): JSX.Element => {
  const { site } = useContext(SiteContext);
  const { user } = site;
  const cms = site.content.productPage;

  const {
    journey,
    onUpdateProducts,
    onUpdateProductDocuments,
    setIsExpiredMessageAcknowledged
  } = useJourney();

  const {
    products,
    vehicle,
    foundExistingQuotes,
    quoteProducts,
    hasQuoteExpired,
    isExpiredMessageAcknowledged
  } = journey;

  const setIsMessageAcknowledged = () => {
    if (setIsExpiredMessageAcknowledged) {
      setIsExpiredMessageAcknowledged(true);
    }
  };

  const productFilter: ProductFilter = {
    dealerCode: user.dealerCode,
    firstRegistrationDate: vehicle.vehicleDetails.registrationDate,
    vehiclePurchaseDate: getFormattedDate(vehicle.vehicleDeliveryDate),
    vehicleValue: vehicle.vehiclePurchasePrice,
    currentMileage: vehicle.currentMileage ?? 0,
    modelTrimId: vehicle.vehicleDetails.modelTrimId,
    fuelTypeId: vehicle.vehicleDetails.fuelTypeCode,
    engineSize: parseInt(vehicle.vehicleDetails.engineSize),
    enginePowerBHP: vehicle.vehicleDetails.enginePowerBHP ?? 0,
    enginePowerKWH: vehicle.vehicleDetails.enginePowerKWH ?? 0,
    driveTypeId: vehicle.vehicleDetails.driveTypeId?.toString() ?? '',
    vrn: vehicle.vehicleDetails.vrn,
    channel: ProductChannel.DealerJourney,
    gapDate: getFormattedDate(vehicle.vehicleGapIntroductionDate) ?? '',
    countryCode: site.countryCode
  };

  return (
    <ProductManager
      products={products}
      productFilter={productFilter}
      foundExistingQuotes={foundExistingQuotes}
      cms={cms}
      onUpdateProducts={onUpdateProducts}
      onUpdateProductDocuments={onUpdateProductDocuments}
      token={user.token}
      quoteProducts={quoteProducts}
      hasQuoteExpired={hasQuoteExpired}
      isExpiredMessageAcknowledged={isExpiredMessageAcknowledged}
      setIsExpiredMessageAcknowledged={setIsMessageAcknowledged}
      showKeyBenefits={true}
      showQuotedPrice={true}
      showKeyBenefitsInProductCard={false}
    />
  );
};

export default ProductPage;
